import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import { Button } from "primereact/button";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";

const useAccumulatorOverrideScheduleCriteria = () => {
  const [data, setData] = useState([]);
  const { axios_helper_no_header } = useAxios();
  const {
    ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    ACCUMULATOR_OVERRIDE_SCHEDULE,
    ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
  } = ROUTE_PATHS;

  const location = useLocation();
  // const { selectedPriceSchedules = [],
  //   previousScreen = '/accumulator-overrride-schedule',
  //   currentIndex: initialIndex = 0,
  //   rowData} = location.state || {};

  // const { state: stateVal } = location;
  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return { currentState, previousState };
  }, [stateVal]);

  //console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules,
    previousScreen,
    initialIndex,
    initialExternalMode,
  } = useMemo(() => {
    let {
      selectedSchedules = [],
      previousScreen = ACCUMULATOR_OVERRIDE_SCHEDULE,
      currentIndex: initialIndex = 0,
      externalMode: initialExternalMode = false,
    } = currentState;
    return {
      selectedSchedules,
      previousScreen,
      initialIndex,
      initialExternalMode,
    };
  }, [currentState]);

  const [paramsData, setParamsData] = useState({
    aosAccumOvrdSchedule: selectedSchedules[initialIndex]?.aosAccumOvrdSchedule,
    aosAccumOvrdScdeDesc: selectedSchedules[initialIndex]?.aosAccumOvrdScdeDesc,
    aosAccumOvrdScdeType: selectedSchedules[initialIndex]?.aosAccumOvrdScdeType,
  });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const toast = useToast();

  const screen_title = "Accumulator Override Schedule Criteria";
  const screenNumber = "RCAOC001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "AOS Accum Ovrd Schedule",
      name: "aosAccumOvrdSchedule",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 15,
    },
    {
      fieldLabel: "AOS Accum Ovrd Scde Descscription",
      name: "aosAccumOvrdScdeDesc",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "AOS Accum Ovrd Scde Type*ALL values",
      name: "aosAccumOvrdScdeType",
      label: "Type",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 50,
    },
  ];

  const dropdownOptions = [
    { field_label: "AOS Accum Ovrd Scde Type", condition: "*ALL values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add Accumulator Override Schedule Criteria",
      button_handeler: () => {
        navigateToPage("/add-accumulator-override-schedule-criteria", [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        navigateToPage("/edit-accumulator-override-schedule-criteria", [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedCriterias: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage("/display-accumulator-override-schedule-criteria", [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedCriterias: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      },
    },
    paramsData.aosAccumOvrdScdeType === "O" ||
    paramsData.aosAccumOvrdScdeType === "D"
      ? {
          label: "State CSR Criteria",
          icon: <span className="material-icons">assignment</span>,
          command: () => {
            navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_STATE, [
              ...previousState,
              { ...currentState, currentIndex, externalMode },
              {
                selectedCriterias: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
                paramsData,
              },
            ]);
          },
        }
      : null,
  ].filter(Boolean);

  /* Data table column info. */
  const columnDef = [
    {
      header: "Seq",
      field: "aocSeqNbr",
    },
    {
      header: "Cust Loc",
      field: "aocCustomerLocation",
    },
    {
      header: "Pat Res",
      field: "aocPatientResidence",
    },
    {
      header: "Compd",
      field: "aocCompoundCode",
    },
    {
      header: "Drug Status",
      field: "aocDrugStatus",
    },
    {
      header: "Days Supply From",
      field: "aocDaysSupplyFrom",
    },
    {
      header: "Days Supply To",
      field: "aocDaysSupplyTo",
    },
    {
      header: "Maint",
      field: "aocMaintenance",
    },
    {
      header: "DEA Class",
      field: "aocDeaClassList",
      body: (rowData) => {
        return (
          <Button
            label={rowData.aocRouteOfAdminList}
            link
            onClick={() => {
              const message = {
                message: "navigate-to-presto",
                programCode: "RCDCL003I",
                parameters: {
                  dclDeaClassList: rowData.aocDeaClassList,
                  workInitialProgramMode: "DSP"
                },
              };
              console.log("message", message);
               window.top?.postMessage(message, "*");
            }}
          />
        );
      },
    },
    {
      header: "Phm Disp Type",
      field: "aocPharDispenserType",
    },
    {
      header: "Tier",
      field: "aocTier",
    },
    {
      header: "OTC",
      field: "aocOtc",
    },
    {
      header: "3rd Party",
      field: "aocThirdPartyException",
    },
    {
      header: "Route of Admin",
      field: "aocRouteOfAdminList",
      body: (rowData) => {
        return (
          <Button
            label={rowData.aocRouteOfAdminList}
            link
            onClick={() => {
              const message = {
                message: "navigate-to-presto",
                programCode: "RCRAL003I",
                parameters: {
                  ralList: rowData.aocRouteOfAdminList,
                },
              };
              console.log("message", message);
               window.top?.postMessage(message, "*");
            }}
          />
        );
      },
    },
    {
      header: "Dosage Form",
      field: "aocDosageFormList",
      body: (rowData) => {
        return (
          <Button
            label={rowData.aocDosageFormList}
            link
            onClick={() => {
              const message = {
                message: "navigate-to-presto",
                programCode: "RCDFL003I",
                parameters: {
                  dflDosageFormList: rowData.aocDosageFormList,
                },
              };
               console.log("message", message);
               window.top?.postMessage(message, "*");
            }}
          />
        );
      },
    },
    {
      header: "Packaging",
      field: "aocPackagingList",
      body: (rowData) => {
        return (
          <Button
            label={rowData.aocPackagingList}
            link
            onClick={() => {
              const message = {
                message: "navigate-to-presto",
                programCode: "RCPKL003I",
                parameters: {
                  pklPackagingList: rowData.aocPackagingList,
                  workInitialProgramMode: 'DSP'
                },
              };
              console.log("message", message);
              window.top?.postMessage(message, "*");
            }}
          />
        );
      },
    },
    {
      header: "Schedule Override",
      field: "aocScheduleOverride",
      body: (rowData) => {
        return (
          <Button
            label={rowData.aocScheduleOverride}
            link
            onClick={(e) => {
               navigateToPage(ROUTE_PATHS.DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE, [
                 ...previousState,
                 { ...currentState, paramsData: paramsData, currentIndex },
                 {
                   previousScreen: location.pathname,
                   paramsData: rowData,
                   currentIndex: 0,
                   selectedSchedules: [{...rowData, opcScheduleName: rowData.aocScheduleOverride}],
                 },
               ]);
            }}
          />
        );
      },
    },
    {
      header: "Indicators",
      field: "reverseVideoIndicator",

      body: (rowData) => (
        <IndicatorCell
          rowData={rowData}
          fields={[
            "reverseVideoIndicator",
            "schdOverrideIndicator",
          ]}
          tooltipContent={{
            reverseVideoIndicator: "HIM",
            schdOverrideIndicator: "State Schedule Override"
          }}
        />
      ),
    },
    // {
    //   header: "",
    //   field: "schdOverrideIndicator",
    // },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "aocSeqNbr";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/aocaccumovrdscdcriteria`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    if (initialIndex !== currentIndex) {
      setParamsData({
        aosAccumOvrdSchedule:
          selectedSchedules[currentIndex]?.aosAccumOvrdSchedule,
        aosAccumOvrdScdeDesc:
          selectedSchedules[currentIndex]?.aosAccumOvrdScdeDesc,
        aosAccumOvrdScdeType:
          selectedSchedules[currentIndex]?.aosAccumOvrdScdeType,
      });
    }
  }, [currentIndex]);

  useEffect(() => {
    setCurrentIndex(initialIndex);
    setParamsData({
      aosAccumOvrdSchedule:
        selectedSchedules[initialIndex]?.aosAccumOvrdSchedule,
      aosAccumOvrdScdeDesc:
        selectedSchedules[initialIndex]?.aosAccumOvrdScdeDesc,
      aosAccumOvrdScdeType:
        selectedSchedules[initialIndex]?.aosAccumOvrdScdeType,
    });
  }, [initialIndex, selectedSchedules]);
  useEffect(() => {
    setExternalMode(initialExternalMode);
  }, [initialExternalMode]);

  useEffect(() => {
    const hasParams =
      paramsData &&
      Object.keys(paramsData).length &&
      paramsData.aosAccumOvrdSchedule;
    if (hasParams) fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteAccumulatorOverrideScheduleCriteria = () => {
    const parmKey = "aocSeqNbr";
    if (selectedOption === "yes") {
      const params = {
        aosAccumOvrdSchedule: paramsData.aosAccumOvrdSchedule,
        aocSeqNbr: rowData[parmKey],
      };
      axios_helper_no_header(
        "DELETE",
        "api/aocaccumovrdscdcriteria",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setData(updatedItems);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/aocaccumovrdscdcriteria/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAccumulatorOverrideScheduleCriteria,
    setSelectedOption,
  };
};

export default useAccumulatorOverrideScheduleCriteria;
